import Vue from 'vue'
import Vuex from 'vuex'

import users from '@/store/user'
import vendors from '@/store/vendors'
import products from '@/store/products'
import uom from '@/store/uom'
import priceLists from '@/store/priceLists'
import branches from '@/store/branches'
import data from '@/store/data'
import taxes from '@/store/taxes'
import warehouses from '@/store/warehouses'
import payments from '@/store/payments'
import banks from '@/store/banks'
import bankGroups from '@/store/bankGroups'
import sales from '@/store/sales'
import city from '@/store/city'
import state from '@/store/state'
import customers from '@/store/customers'
import organizations from '@/store/organizations'
import jobPositions from '@/store/jobPositions'
import delivery from '@/store/deliveries'
import paymentMethods from '@/store/paymentMethods'
import paymentTypes from '@/store/paymentTypes'
import workorders from '@/store/workorders'
import costs from '@/store/costs'
import workshops from '@/store/workshops'
import workshopTypes from '@/store/workshopTypes'
import woTermCategories from '@/store/woTermCategories'
import woTerms from '@/store/woTerms'
import inventories from '@/store/inventories'
import projects from '@/store/projects'
import accounts from '@/store/accounts'
import journals from '@/store/journals'
import cards from '@/store/cards'
import levels from '@/store/levels'
import packages from '@/store/packages'
import promos from '@/store/promos'
import purchasingTypes from '@/store/purchasingTypes'
import variants from '@/store/variants'
import assets from '@/store/assets.js'
import termduedates from '@/store/termduedates.js'
import companies from '@/store/companies.js'
import employees from '@/store/employees.js'
import purchasings from '@/store/purchasings.js'
import area from '@/store/areas.js'
import manufactures from '@/store/manufactures.js'
import cohs from '@/store/cohs.js'
import returs from '@/store/returs.js'
import units from '@/store/units.js'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    users,
    vendors,
    products,
    uom,
    priceLists,
    branches,
    data,
    taxes,
    warehouses,
    payments,
    banks,
    sales,
    city,
    state,
    area,
    customers,
    organizations,
    jobPositions,
    bankGroups,
    delivery,
    paymentMethods,
    paymentTypes,
    workorders,
    costs,
    workshops,
    workshopTypes,
    woTermCategories,
    woTerms,
    inventories,
    projects,
    accounts,
    journals,
    cards,
    promos,
    packages,
    levels,
    purchasingTypes,
    variants,
    assets,
    termduedates,
    companies,
    employees,
    purchasings,
    manufactures,
    cohs,
    returs,
    units
  }
})
